// extracted by mini-css-extract-plugin
export default {"cancelMobile":"EN8UQCWnEihjk3cL1dQb"};